var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPart',{attrs:{"Item":_vm.Ticket,"setItemForm":_vm.setItemForm,"submitData":_vm.submitData},on:{"onSuccess":_vm.onSuccess,"onFail":_vm.onFail},scopedSlots:_vm._u([{key:"default",fn:function({
        loading
      }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"type":"submit","rounded":true,"outlined":true,"loading":loading,"disabled":loading,"color":"primary"}},[_c('v-icon',[_vm._v(" mdi-cash ")]),_vm._v(" Vybrať ")],1)],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }